import { render, staticRenderFns } from "./Lessons.vue?vue&type=template&id=a6ad151c&scoped=true&"
import script from "./Lessons.vue?vue&type=script&lang=ts&"
export * from "./Lessons.vue?vue&type=script&lang=ts&"
import style0 from "./Lessons.vue?vue&type=style&index=0&id=a6ad151c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6ad151c",
  null
  
)

export default component.exports